import { Redirect, Route, Router, Switch } from './reactRouterDom';
import Loader from '@reportdev-datalake/core-lib/components/Loader';
import PageLoader from '@reportdev-datalake/ui-lib/base/loader/PageLoader';
import Logout from '@/containers/Auth/Logout';

const Admin = Loader({
  loader: () => import('./admin'),
  fallback: PageLoader,
});

const Auth = Loader({
  loader: () => import('./auth'),
  fallback: PageLoader,
});

const OAuth2Consent = Loader({
  loader: () => import('../containers/Auth/OAuth2ConsentPage'),
  fallback: PageLoader,
});

const DataAgents = Loader({
  loader: () => import('./dataAgents'),
  fallback: PageLoader,
});

function App() {
  return (
    <Router>
      <>
        <Switch>
          <Route exact path="/">
            <Redirect to="/admin" />
          </Route>
          <Route exact path="/admin/signout" component={Logout} />
          <Route path="/oauth2/consent" component={OAuth2Consent} />
          <Route path="/auth" component={Auth} />
          <Route path="/data-agents" component={DataAgents} />
          <Route path="/admin" component={Admin} />
        </Switch>
      </>
    </Router>
  );
}

export default App;
